module.exports = __webpack_public_path__ + "img/68.1ea9710b.jpg";